/* eslint-disable prettier/prettier */
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import editIcon from '../../assets/images/svg/edit.svg';
import closeIcon from '../../assets/images/svg/close.svg';
import './familyDetailBox.css';

function FamilyDetailBox(props) {
  const { memberImage, name, relation, phone, email, height, weight, dob } = props;
  return (
    <div className="familyDetailBox">
      <div className="iconBox">
        <Link to="/">
          <img src={editIcon} alt="editIcon" />
        </Link>
        <button type="button">
          <img src={closeIcon} alt="closeIcon" />
        </button>
      </div>
      <Row>
        <Col md={2}>
          <div className="imgBox">
            <img src={memberImage} alt="memberImage" />
          </div>
        </Col>
        <Col md={8}>
          <div className="detailBox">
            <ul>
              <li>
                <span> {name} </span>
              </li>
              <li>
                Relationship <span> {relation}</span>
              </li>
              <li>
                Phone Number <span>{phone}</span>
              </li>
              <li>
                Email Address <span>{email} </span>
              </li>
              <li>
                Height in cm <span>{height} </span>
              </li>
              <li>
                Weight in kg <span>{weight} </span>
              </li>
              <li>
                Date of Birth <span>{dob}</span>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default FamilyDetailBox;
